import type { ModalId } from "@@/modals/context/modal-id";
import { Modal } from "@@/modals/modal";
import { useModalActions } from "@@/modals/use-modal-actions";
import { ButtonPrimary } from "@@/shared/buttons_v2/button-primary";
import { VerticalDivider } from "@@/shared/dividers";
import { FlexColumn } from "@@/shared/flex-containers";
import { QRCode } from "@@/shared/qr-code";
import { TextBox } from "@@/shared/text";
import { translation } from "@towni/common";

type Props = {
    modalId: ModalId;
    code?: string;
};

const LasseShowQrModal = (props: Props) => {
    const { hide } = useModalActions(props.modalId);
    return (
        <Modal modalId={props.modalId}>
            <FlexColumn
                crossAxis="center"
                mainAxis="space-between"
                fillParent
                padding={{ all: 20 }}>
                <QRCode value={props.code ?? ""} size={300} />
                <VerticalDivider XL />
                <ButtonPrimary onClick={hide} fillParentWidth>
                    <TextBox text={translation({ sv: "Stäng", en: "Close" })} />
                </ButtonPrimary>
            </FlexColumn>
        </Modal>
    );
};

export { LasseShowQrModal };
